import { render, staticRenderFns } from "./AdminReportForm.vue?vue&type=template&id=41066ac5&scoped=true"
import script from "./AdminReportForm.vue?vue&type=script&lang=js"
export * from "./AdminReportForm.vue?vue&type=script&lang=js"
import style0 from "./AdminReportForm.vue?vue&type=style&index=0&id=41066ac5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41066ac5",
  null
  
)

export default component.exports